/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClockCode = createReactComponent("clock-code", "IconClockCode", [
  ["path", { d: "M20.931 13.111a9 9 0 1 0 -9.453 7.874", key: "svg-0" }],
  ["path", { d: "M20 21l2 -2l-2 -2", key: "svg-1" }],
  ["path", { d: "M17 17l-2 2l2 2", key: "svg-2" }],
  ["path", { d: "M12 7v5l2 2", key: "svg-3" }]
]);

export { IconClockCode as default };
//# sourceMappingURL=IconClockCode.js.map
